/**
 * Resolves the deployment environment, mirroring `getBaseURL()`: the runtime override
 * written by docker-entrypoint.sh first, then the build-time value.
 *
 * Does NOT default to `development`. Call sites treat that value as a bypass
 * (`EncryptPayload` returns the payload unencrypted), so unset must stay unset.
 */
export const getEnv = (): string | undefined => {
	const runtime_env = typeof window !== 'undefined' ? window.__ENV__?.REACT_APP_ENV : undefined;
	if (runtime_env) {
		return runtime_env;
	}

	return process.env.REACT_APP_ENV;
};

/**
 * ReCaptcha is off for local development only — assessments are billed, and the dev site key
 * isn't authorised for localhost. Anything else (including an unset env) keeps it on.
 */
export const isRecaptchaDisabled = (): boolean => getEnv() === 'development';
